import PostList from './post-list';

const postListConfig = {
  name: 'postList',
  class: PostList,
  querySelector: {
  },
  querySelectorAll: {
    postMobileSliders: '.post-list__mobile-slider',
  },
  options: {},
};

export default postListConfig;
